<template>
  <div class="dialog-options-setting-dialog">
    <div class="content-group-default">
      <el-collapse v-model="activeNames" style="width: 100%">
      <el-collapse-item title="弹出框动画" name="2">
        <!--类型-->
        <cx-select class="mt8" :value.sync="dialogAnimateType" :selectOptions="dialogAnimateTypeList" title="打开动画" />
        <div class="mt16">
          <slider-and-input
              class="mt8"
              title="持续时间"
              :value.sync="dialogAnimateTime"
              :sliderMax="10"
              suffix="s"
          />
        </div>
      </el-collapse-item>
        <el-collapse-item title="弹出框设置" name="1">
          <div class="verticallyCenter mb8 set-item-28" style="padding:0 40px;">
            <span class="fs14 mr8">弹出框宽度</span>
            <div class="number-input-box flex1">
              <el-input
                class="percent100"
                style="width: 100%"
                v-model="dialogWidth"
                v-inputHandle="{ this1, type: 'dialogWidth' }"
                placeholder="请输入"
                :controls="false"
                type="number"
                @focus="getFocus($event)"
              >
                <template slot="suffix">
                  <span class="suffix_text">px</span>
                </template>
              </el-input>
            </div>
          </div>
          <div class="verticallyCenter mb8 set-item-28" style="padding:0 40px;">
            <span class="fs14 mr8">弹出框高度</span>
            <div class="number-input-box flex1">
              <el-input
                class="percent100"
                style="width: 100%"
                v-model="dialogHeight"
                v-inputHandle="{ this1, type: 'dialogHeight' }"
                placeholder="请输入"
                :controls="false"
                type="number"
                @focus="getFocus($event)"
              >
                <template slot="suffix">
                  <span class="suffix_text">px</span>
                </template>
              </el-input>
            </div>
          </div>
          <div class="data-item mt16 verticallyCenter">
            <cx-check-box :value.sync="dialogPositionPercent">位置使用百分比</cx-check-box>
          </div>
          <div v-if="dialogPositionPercent">
            <slider-and-input
                title="横"
                class="mt8"
                :value.sync="dialogLeft"
                :sliderMax="100"
                suffix="%"
            />
            <slider-and-input
                title="竖"
                class="mt8"
                :value.sync="dialogTop"
                :sliderMax="100"
                suffix="%"
            />
          </div>
          <div class="data-item mt16" v-else>
            <double-input
                title="位置"
                placeHolderText="必填"
                :value1.sync="dialogLeft"
                :value2.sync="dialogTop"
                :inputSuffixs="['横', '竖']"
            />
          </div>
          <div class="bg-style mt16">
            <p class="mb8">背景遮罩颜色</p>
            <color-picker :color.sync="dialogBackgroundColor" />
            <p class="mt16">背景虚化</p>
            <slider-and-input
                class="mt8"
                :value.sync="dialogBackgroundFilter"
                :sliderMax="250"
                suffix="px"
            />
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>

<script>
import $ from "jquery"
export default {
  name: "dialog-options-setting",
  props: { options: Object },
  data() {
    return {
      activeNames: [],
      countCol: 1,
      this1: this,
      dialogAnimateTypeList: [
        {
          label: "默认",
          value: 0
        },
        {
          label: "淡入",
          value: 1
        },
        {
          label: "放大",
          value: 2
        },
        {
          label: "向右进入",
          value: 3
        },
        {
          label: "向左进入",
          value: 4
        },
        {
          label: "向上进入",
          value: 5
        },
        {
          label: "向下进入",
          value: 6
        },
      ]
    }
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    dialogWidth: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "dialogWidth", "dialogWidth", 400)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "dialogWidth", false)
      }
    },
    dialogHeight: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "dialogHeight", "dialogHeight", 400)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "dialogHeight", false)
      }
    },
    dialogPositionPercent: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "dialogPositionPercent", "dialogPositionPercent", true)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "dialogPositionPercent", false)
      }
    },
    dialogLeft: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "dialogLeft", "dialogLeft", 50)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "dialogLeft", false)
      }
    },
    dialogTop: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "dialogTop", "dialogTop", 50)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "dialogTop", false)
      }
    },
    dialogBackgroundColor: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "dialogBackgroundColor", "dialogBackgroundColor", "rgba(0,0,0,0.3)")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "dialogBackgroundColor", false)
      }
    },
    dialogBackgroundFilter: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "dialogBackgroundFilter", "dialogBackgroundFilter", 5)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "dialogBackgroundFilter", false)
      }
    },
    dialogAnimateType: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "dialogAnimateType", "dialogAnimateType", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "dialogAnimateType", false)
      }
    },
    dialogAnimateTime: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "dialogAnimateTime", "dialogAnimateTime", 1)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "dialogAnimateTime", false)
      }
    }
  },
  mounted(){
    this.removeSettingHandle();
  },
  methods:{
    getFocus(event) {
      event.currentTarget.select()
    },
    // 去掉部分配置项
    removeSettingHandle:function(){
      let settingList = $(this.$el).parents('.text-options-setting-dialog').find('.el-collapse-item');
      const choosStyleSetting = $(this.$el).parents('.text-options-setting-dialog').prev();
      $(choosStyleSetting).hide();
      settingList.each(function(index,item){
        const itemName = $(item).find('.el-collapse-item__header').text();
        if(itemName==='边距'||itemName==='动画设置') {
          $(item).hide();
        }
      })
    }
  }
}
</script>

<style scoped >
  .el-radio.mr20 {
    margin-right: 20px;
  }
</style>
